import BulkAssignment from './assignment/BulkAssignment';
import React from 'react';
import BulkStatus from './status/BulkStatus';
import { ApiAssignmentUser, ApiNote } from '../../api';
import { InternalApiAlertType } from '../../api-internal';
import { AlertInfo } from '../../screening/alert/filters/ScreeningAlertFiltersResults';

export const getBulkAssignment = (
  selectedAlerts: AlertInfo[],
  updateSanctionAlerts: (apiAssignmentUser: ApiAssignmentUser) => void
) => {
  if (selectedAlerts.length === 0) {
    return <th className='assignee-header'>ASSIGNEE</th>;
  } else {
    return (
      <th className='assignee-header'>
        <BulkAssignment updateAlerts={updateSanctionAlerts} />
      </th>
    );
  }
};

export const getBulkStatus = (
  selectedAlerts: AlertInfo[],
  alertType: InternalApiAlertType,
  updateSanctionAlerts: (note: ApiNote, status: string) => void,
  onComplete: () => void
) => {
  if (selectedAlerts.length === 0) {
    return <th className='status-header'>STATUS</th>;
  } else {
    return (
      <th className='status-header'>
        <BulkStatus
          selectedAlerts={selectedAlerts}
          alertType={alertType}
          updateSanctionAlerts={updateSanctionAlerts}
          onComplete={onComplete}
        />
      </th>
    );
  }
};
